import { render, staticRenderFns } from "./createVersion.vue?vue&type=template&id=6d8216f2&scoped=true&"
import script from "./createVersion.vue?vue&type=script&lang=js&"
export * from "./createVersion.vue?vue&type=script&lang=js&"
import style0 from "./createVersion.vue?vue&type=style&index=0&id=6d8216f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8216f2",
  null
  
)

export default component.exports